import { useEffect } from 'react';
import * as React from 'react';
import { observer } from 'mobx-react';
import { useSearchParams } from 'react-router-dom';
import NavigationWrapper from '../Components/Navigation/NavigationWrapper';
import { HOME_SEARCH_PAGE_TITLE } from 'ConstantPageNames';
import HomeSearch from 'Modules/Home/Components/HomeSearch';
import SecuredPage from '../Components/Security/SecuredPage';
import { store } from 'Models/Store';
import MarketingBanner from '../Components/_HumanWritten/MarketingBanner';

export interface HomeSearchPageProps {}

export function HomeSearchPage() {
	useEffect(() => {
		document.title = HOME_SEARCH_PAGE_TITLE;
	}, []);

	// `type` arrives in the query string (/home/search?type=cargo), not as a route segment.
	const [searchParams] = useSearchParams();
	const type = searchParams.get('type');

	return (
		<SecuredPage>
			<NavigationWrapper />
			<div className="body-content">
				<HomeSearch type={type ?? ''} />
				<div className="absolute-position">
					{/* <PoweredByFerryHawk /> */}
					{!store.isManager && <MarketingBanner />}
				</div>
			</div>
		</SecuredPage>
	);
}

export default observer(HomeSearchPage);
